import utils from "../utils/utils";

/*
 * General purpose simple filters - Functions definition
 */

/**
 * Brazilian CPF number filter
 */
const cpf = () => input => {
	if (!utils.isEmpty(input))
		return input.mask('000.000.000-00');

	return "";
};

/**
 * Show a '-' when filtered value is empty
 */
const dash = () => input => !utils.isEmpty(input) ? input : "-";

/**
 * Resolve labels from Cooperforte WordPress label service
 * @ngInject
 */
const cfLabel = (labelService) => input => !utils.isEmpty(input) ? labelService.getLabelByExpression(input) : "";

export default {
	cpf,
	dash,
	cfLabel
}



// WEBPACK FOOTER //
// ./src/app/misc/filters/general.filter.js